import * as z from 'zod'

import { BaseSchema_DentalV1GetsafeDe } from '@flows/insurance/schemas'

/**
 * Schema that converts the flow data according to the format required by BE
 */
export const schema = z.preprocess((values) => {
  const valuesCopy = { ...(values as Record<string, any>) }

  // Clean up previous insurance fields if previous_insurance is not 'true'
  if (valuesCopy.previous_insurance !== 'true') {
    delete valuesCopy.previous_insurer
    delete valuesCopy.previous_insurance_start_date
    delete valuesCopy.previous_insurance_end_date
    delete valuesCopy.previous_insurance_covers_min_75_percent_dental_replacements
  }

  return {
    ...valuesCopy,
  }
}, BaseSchema_DentalV1GetsafeDe)
